import React from 'react'
import styled from 'styled-components'
import { IoIosCloseCircle } from 'react-icons/io'

export const CloseIcon = props => {
  return (
    <Root { ...props }>
      <IoIosCloseCircle />
    </Root>
  )
}

const Root = styled.div`
  svg {
    font-size: ${p => p.fontSize || '24px'};
    color: ${p => p.color || '#C4C4C4'};
    cursor: pointer;
  }
`



// WEBPACK FOOTER //
// ./src/components/icons/close-icon.js